import { print } from 'graphql';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';
import { MigrationStrategies } from 'rxdb';

import { gql } from '../../graphql/Client';
import { BaseEntity } from '../../models/BaseEntity';
import { generatePullQuery, PullQueryContext } from '../queryBuilders/generatePullQuery';
import { defaultDocAllTime } from '../Shared/defaultDoc';

export interface Inspection extends BaseEntity {
  readonly id: string;
  readonly description: string;
  readonly inspectionType: string;
  readonly miningMethod: string;
  readonly needsHazard: boolean;
  readonly equipmentTypeName: string;
  readonly supportedLocationTypes: string;
}
export type InspectionCollection = RxCollection<Inspection> | null;
export type InspectionDocument = RxDocument<Inspection>;

export const inspectionSchema: RxJsonSchema<Inspection> = {
  type: 'object',
  version: 1,
  description: 'describes a Inspection object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    inspectionType: { type: 'string' },
    isDeleted: { type: 'boolean' },
    miningMethod: { type: 'string' },
    needsHazard: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
    equipmentTypeName: { type: ['string', 'null'] },
    supportedLocationTypes: { type: ['string', 'null'] },
  },
};

export const inspectionMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: InspectionDocument) => ({ ...oldDoc }),
};

const inspectionFeedQuery = print(gql`
  query inspectionFeed($siteId: ID!, $lastUpdateAt: Float!, $limit: Int!, $isLegacy: Boolean) {
    inspectionFeed(
      lastUpdateAt: $lastUpdateAt
      limit: $limit
      siteId: $siteId
      isLegacy: $isLegacy
    ) {
      id
      description
      inspectionType
      isDeleted
      miningMethod
      needsHazard
      updatedAt
      version
      equipmentTypeName
      supportedLocationTypes
    }
  }
`);

export const inspectionPullQueryBuilder = generatePullQuery(
  inspectionFeedQuery,
  PullQueryContext.Site,
  defaultDocAllTime,
  {
    isLegacy: false,
  },
);
